import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import {
    deleteTemplateWallpaper, addTemplateWallpaper, getTemplateWallpaper,
    deleteAndroidTemplateWallpaper, addAndroidTemplateWallpaper, getAndroidTemplateWallpaper, deleteAndroidDevice
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentWallpaper = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [tableList, setTableList] = useState<any[]>([]);
    const [dataForm] = Form.useForm();
    const [lockScreenUrl, setLockScreenUrl] = useState<any>();
    const [homeScreenUrl, setHomeScreenUrl] = useState<any>();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [lockScreenChanged, setLockScreenChanged] = useState<boolean>(false);
    const [homeScreenChanged, setHomeScreenChanged] = useState<boolean>(false);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    const getDataInfo = () => {
        if (platform == "Android") {
            getAndroidTemplateWallpaper(templateId).then((res) => {
                if (res && res != null) {
                    setShowTable(2)
                    setIsUpload(true)
                    var result = {
                        AllowWallpaperModification: res.isAllowModification
                    }
                    setHomeScreenUrl(res.wallpaperUrl);
                    dataForm?.setFieldsValue(result);
                } else {
                    setShowTable(1)
                }

            })
        } else {
            getTemplateWallpaper(templateId).then((res) => {
                if (res && res != null) {
                    setShowTable(2)
                    setIsUpload(true)
                    setHomeScreenUrl(res.homeScreenUrl);
                    setLockScreenUrl(res.lockScreenUrl);
                    res.AllowWallpaperModification = res.allowWallpaperModification;
                    dataForm?.setFieldsValue(res);
                } else {
                    setShowTable(1)
                }
            })
        }
    }
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const beforeUpload = (file: File) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            notification.error({ message: t("You can only upload JPG/PNG file!") });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({ message: t("Image must smaller than 2MB!") });
        }
        return false;
    };

    const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        setHomeScreenChanged(true)
        getBase64(info.file, (imageUrl: any) => {

            setHomeScreenUrl(imageUrl);
        });
    };
    const handleChange2 = (info: UploadChangeParam<UploadFile<any>>) => {
        setLockScreenChanged(true)
        getBase64(info.file, (imageUrl: any) => {
            setLockScreenUrl(imageUrl);
        });
    };
    function getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            callback(reader.result);
        });
        reader.readAsDataURL(img);
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                if (platform == "Android") {
                    const { AllowWallpaperModification, HomeScreen } = res;
                    var arg = {
                        isAllowModification: AllowWallpaperModification,
                        Wallpaper: HomeScreen ? (HomeScreen[0]?.originFileObj) : "",
                    }
                    addAndroidTemplateWallpaper(templateId, arg).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                } else {
                    const { AllowWallpaperModification, HomeScreen, LockScreen } = res;
                    var ag = {
                        AllowWallpaperModification: AllowWallpaperModification,
                        HomeScreen: HomeScreen ? (HomeScreen[0]?.originFileObj) : "",
                        LockScreen: lockScreenUrl ? (LockScreen ? (LockScreen[0]?.originFileObj) : "") : "",
                        HomeScreenChanged: homeScreenChanged,
                        LockScreenChanged: lockScreenChanged,
                    }
                    addTemplateWallpaper(templateId, ag).then(() => {
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                }
            })
    }
    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            if (platform == "Android") {
                deleteAndroidTemplateWallpaper(templateId).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    setHomeScreenUrl("");
                    setHomeScreenChanged(false);
                    setLockScreenUrl("");
                    setLockScreenChanged(false);
                    getDataInfo();
                })
            } else {
                deleteTemplateWallpaper(templateId).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    setHomeScreenUrl("");
                    setHomeScreenChanged(false);
                    setLockScreenUrl("");
                    setLockScreenChanged(false);
                    getDataInfo();
                })
            }
        })

    }
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("墙纸")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置手机锁屏以及主屏壁纸,此模式需要在收监督的设备中使用")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentWallpaper", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 8 }}
                            initialValues={{ tags: [] }}
                        >
                            <Row>
                                <Col span={16}>
                                    <Item
                                        label={t("主屏壁纸")}
                                        name="HomeScreen"
                                        rules={[{ required: !isUpload }]}
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra={<><InfoCircleOutlined /> {t("壁纸尺寸需要符合设备尺寸,最大不超过2MB")}</>}
                                    >
                                        <Upload
                                            maxCount={1}
                                            listType="picture-card"
                                            accept=".png,.jpg,.jpeg"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={handleChange}
                                        >
                                            {homeScreenUrl ? (
                                                <img src={homeScreenUrl} alt="avatar" style={{ height: 100 }} />
                                            ) : (
                                                "+"
                                            )}
                                        </Upload>
                                    </Item>
                                </Col>

                            </Row>
                            {platform == "IOS" && (

                                <Row>
                                    <Col span={16}><Item

                                        label={t("锁屏壁纸")}
                                        name="LockScreen"
                                        rules={[{ required: !isUpload }]}
                                        valuePropName="fileList"
                                        getValueFromEvent={normFile}
                                        extra={<><InfoCircleOutlined /> {t("壁纸尺寸需要符合设备尺寸,最大不超过2MB")}</>}
                                    >
                                        <Upload
                                            maxCount={1}
                                            listType="picture-card"
                                            accept=".png,.jpg,.jpeg"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            onChange={handleChange2}
                                        >
                                            {lockScreenUrl ? (
                                                <img src={lockScreenUrl} alt="avatar" style={{ height: 100 }} />
                                            ) : (
                                                "+"
                                            )}
                                        </Upload>
                                    </Item>
                                    </Col>
                                    {lockScreenUrl && (
                                        <Col span={2} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}>
                                            <a onClick={() => { setLockScreenUrl(null); setLockScreenChanged(true); gaEvent("templateContentWallpaper", "onClick", "setLockScreenChanged") }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px", color: "#007ACC" }} >移除</a>
                                        </Col>
                                    )}
                                </Row>
                            )}

                            <Row>
                                <Col span={16}>
                                    <Item label={t("允许修改")} name="AllowWallpaperModification" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("用户无法修改墙纸")}</>}>
                                        <Radio.Group defaultValue={1}>
                                            <Radio value={true}>{t("是")}</Radio>
                                            <Radio value={false}>{t("否")}</Radio>
                                        </Radio.Group>
                                    </Item>
                                </Col>
                                {/* <Col span={8} >
                                    <p style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;用户无法修改墙纸</p>
                                </Col> */}
                            </Row>

                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentWallpaper", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentWallpaper", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};